import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ colors, spacing }) => ({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.backgroundDefault,
    padding: spacing(4),
    _web: {
      minHeight: "90svh",
    },
  },
  icon: {
    width: spacing(12),
    height: spacing(12),
    color: colors.foregroundDefault,
    marginBottom: spacing(4),
  },
  title: {
    marginBottom: spacing(2),
  },
  subtitle: {
    color: colors.foregroundDefault,
  },
  cta: {
    marginTop: spacing(6),
    width: "100%",
    alignItems: "center",
  },
}));

export default stylesheet;
